import { Pipe, PipeTransform } from '@angular/core';
import { ISegment, ISegments } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

@Pipe({
    name: 'hasOtherSegments'
})

export class HasOtherSegmentsPipe implements PipeTransform {
    public transform(segments: ISegments): boolean {
        return !!Object.values(segments)
            .find((segment: ISegment) => segment.journey.length > 1);
    }
}
